import React, { useRef } from 'react';
import { Radio } from '../Radio/Radio';
export function SegmentControlSegment(props) {
    const { children, value, label, disabled, ...rest } = props;
    const inputRef = useRef(null);
    return (React.createElement(Radio, { ...rest, disabled: disabled, value: value !== null && value !== void 0 ? value : label, "data-label": label, onClick: () => {
            if (disabled)
                return;
            if (inputRef.current) {
                inputRef.current.click();
            }
        }, className: "mollie-ui-segment-control-segment", UNSAFE_elementType: "div", inputRef: inputRef, UNSAFE_indicatorClassName: "mollie-ui-segment-control-segment-indicator", UNSAFE_indicatorContent: label }));
}
SegmentControlSegment.displayName = 'SegmentControl.Segment';
//# sourceMappingURL=SegmentControlSegment.js.map